import Environment from '@config/index';

export type ColorOptions = {
  hexadecimal?: string;
  assetUrl?: string;
  noColor?: boolean;
};

// Colors are passed in following pattern: Colorname#ColorId
const colorSwatchColorMap = (color: string) => {
  const colorId: number = Number(color);

  const colorMap: { [p: number]: ColorOptions } = {
    1: { hexadecimal: '#FFF' },
    2: { hexadecimal: '#DFC4A3' },
    3: { hexadecimal: '#FAEC67' },
    4: { hexadecimal: '#FFB449' },
    5: { hexadecimal: '#FDC0D7' },
    6: { hexadecimal: '#DD5252' },
    7: { hexadecimal: '#BF55BD' },
    8: { hexadecimal: '#A57738' },
    9: { hexadecimal: '#68A0F2' },
    11: { hexadecimal: '#89B379' },
    12: { hexadecimal: '#97A463' },
    13: { hexadecimal: '#C5C5C5' },
    14: { hexadecimal: '#000000' },
    15: {
      assetUrl: `${Environment.cdnFolder}/assets/img/filters/colors/silver.png`,
    },
    16: {
      assetUrl: `${Environment.cdnFolder}/assets/img/filters/colors/gold.png`,
    },
    17: {
      assetUrl: `${Environment.cdnFolder}/assets/img/filters/colors/multicolor.png`,
    },
    21: { noColor: true },
    53: { hexadecimal: '#4E4E4E' },
    219: { hexadecimal: '#F8F9EC' },
    220: { hexadecimal: '#A04551' },
    221: {
      assetUrl: `${Environment.cdnFolder}/assets/img/filters/colors/metallic.png`,
    },
    222: { hexadecimal: '#C6975A' },
    223: { hexadecimal: '#4E4E4E' }, // TODO: Same as 53?
    224: { hexadecimal: '#325B8C' },
    225: { hexadecimal: '#8DE4DD' },
  };

  return colorMap[colorId];
};

export default colorSwatchColorMap;
